module.exports = __webpack_public_path__ + "assets/img/vemproapp_generica_restaurante_story.484d5e67.png";